import { __decorate } from "tslib";
import { QBtn, QTooltip } from 'quasar';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const debugStore = namespace('DebugStore');
let DebugButton = class DebugButton extends Vue {
    get iconColor() {
        return this.debug ? 'red' : this.color;
    }
    get debug() {
        return this.getDebug;
    }
    set debug(b) {
        this.setDebug(b);
    }
};
__decorate([
    Prop({ required: false, type: String, default: 'black' })
], DebugButton.prototype, "color", void 0);
__decorate([
    debugStore.Getter('debug')
], DebugButton.prototype, "getDebug", void 0);
__decorate([
    debugStore.Mutation('setDebug')
], DebugButton.prototype, "setDebug", void 0);
DebugButton = __decorate([
    Component({
        components: {
            QBtn,
            QTooltip,
        },
    })
], DebugButton);
export default DebugButton;
